import React from 'react'
import { Link } from 'react-router-dom'

import {
  Typography,
  Box
} from '@mui/material'

import { useSelector } from 'react-redux'

const NotFound = () => {
  const { userInfo } = useSelector(state => state.userState)

  return (
    <Box sx={{ mt: 5, maxWidth: 650, mx: 'auto' }}>
      <Typography sx={{ fontWeight: 400 }} variant='h1' align='center' color='primary'>404</Typography>
      <Typography align='center' variant='h5' sx={{ fontWeight: '500' }}>Oops! This page doesn't exist.</Typography>
      <Box mt={3} sx={{ maxWidth: 150, mx: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' }}>
        <Typography variant='button' color='primary'>
          <Link to='/' style={{ color: 'inherit' }}>Home</Link>
        </Typography>
        <Typography variant='button' color='primary'>
          {userInfo ? <Link to='/profile' style={{ color: 'inherit' }}>Profile</Link> :
            <Link to='/login' style={{ color: 'inherit' }}>Login</Link>}
        </Typography>
      </Box>
    </Box>
  )
}

export default NotFound